import { render, staticRenderFns } from "./PlanCheckBox.vue?vue&type=template&id=1887e9a4&"
import script from "./PlanCheckBox.vue?vue&type=script&lang=js&"
export * from "./PlanCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports